
import { useState } from "react";
import Navlink from "../Navlink";
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';

import NavBar from './NavBar.module.css'

const MobileNav = () => {

    const [tap, setTap] = useState(false);
    
    const Hamburger = <MenuRoundedIcon
                        className={NavBar["HamburgerMenu"]}
                        size="30px" 
                        style={{color: '#FF8000'}}
                        fontSize={'large'}
                        onClick={() => setTap(!tap)}
                        />
    
    const Close = <MenuOpenRoundedIcon 
                    className={NavBar["HamburgerMenu"]}
                    size="30px"
                    style={{color: '#FF8000'}}
                    fontSize={'large'}
                    onClick={() => setTap(!tap)}
                    />
                     
                    
    const closeMenu = () => {
        console.log("closeMenu called")
        setTap(false);
    }

    return(
        <nav className={NavBar["MobileNavigation"]}>
            <h3>SEASHORES a Lighthouse Ministry</h3>
            {tap ? Close : Hamburger}
            {tap && <Navlink isClick={true} closeMenu={closeMenu}/>}
        </nav>
    );
}

export default MobileNav;